import React from 'react';
import { SxProps, Theme, styled } from "@mui/material/styles";
import Box from "@vapor/react-material/Box";
import FormHelperText  from '@vapor/react-material/FormHelperText';
import InputLabel from '@vapor/react-material/InputLabel';
import Select from "@vapor/react-material/Select";
import TextField  from '@vapor/react-material/TextField';
import { TextFieldProps } from "@vapor/react-material/TextField";
import { SelectProps } from '@vapor/react-material/Select';
import  FormControl  from '@mui/material/FormControl';
import { VaporCurrencyField } from "../VaporCurrencyField/VaporCurrencyField"
import { VaporCurrencyFieldProps } from "../VaporCurrencyField/VaporCurrencyField";


export type SelectSuffixProps = TextFieldProps & {
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element, on the children property you can decide how the options of the select can be rendered
   */
  selectProps: SelectProps;
  /**
   * Additional helper text content.
   */
  helperText?: React.ReactNode;
  /**
   * If `true`, displays the input in an error state.
   */
  error?: boolean;
  /**
   * The label content.
   */
  label?: string;
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps<Theme>;
  /**
   * The type of the `input` element ("text" | "number" | "currencyFieldType").
   */
  type: "text" | "number" | "currencyFieldType";
  /**
   * The value of the `input` element.
   */
  value: "string" | "number",
  /**
   * Props specific to the VaporCurrencyField component when `type` is "currencyFieldType".
   */
  currencyfieldprops?: VaporCurrencyFieldProps;
};

export const SelectSuffix = styled(
  React.forwardRef<HTMLDivElement, SelectSuffixProps>((props, ref) => {
    const {
      selectProps,
      helperText,
      error,
      label,
      sx,
      disabled,
      type = "text",
      value,
      currencyfieldprops,
      ...other
    } = props;

    const { component, ...otherbox } = props

    return (
      <Box {...otherbox} component={component} display="flex" flexDirection="column">

        {label && <InputLabel disabled={disabled}>{label}</InputLabel>}

        <Box flexDirection="row" display="flex">
          { type === 'currencyFieldType'  ? (
            <VaporCurrencyField
              {...currencyfieldprops} 
              ref={ref}
              value={currencyfieldprops.value ? currencyfieldprops?.value : value}
              // InputProps={{ value: currencyfieldprops?.value ? currencyfieldprops?.value : value }}
              error={error}
              disabled={disabled}
            />
          ) : (
            <TextField
              {...other}
              ref={ref}
              type={type}
              value={value}
              error={error}
              disabled={disabled}
            />
          )}
          <FormControl component={component} disabled={disabled} {...selectProps}>
            <Select
              {...selectProps}
              sx={{ minWidth: "70px", ...selectProps.sx }}
              disabled={disabled}
            >
              {selectProps?.children}
            </Select>
          </FormControl>
        </Box>
        {
          helperText && (
            <FormHelperText disabled={disabled} component="div" sx={sx} error={error}>{helperText}</FormHelperText>
          )
        }

      </Box>
    );
  }),
  {
    name: "SelectSuffix",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({}));

export default SelectSuffix;